import {
  FEE_PAYMENT_SCHEDULE,
  TStatus,
} from '../../apis/finance/finance.interfaces';
import {
  TStudentDetails,
  TEnrollmentHistoryEntry,
  TPreviousSchool,
} from '../../apis/students/students.interfaces';
import { mockDocument } from '../documents/documentMock';
import {
  mockUserDetails,
  mockStudentUserDetails,
} from '../users/userDetailsMock';
import { mockStudentPrimary } from './studentPrimaryMock';
import { mockUserAction } from '../users/userAction';

export const mockStudentDetails: TStudentDetails = {
  ...mockStudentUserDetails,
  ...mockStudentPrimary,
  enrollmentHistory: [
    { academicYear: '2024-2025', grade: '5', section: 'A', instituteName: 'Current School' },
    { academicYear: '2023-2024', grade: '4', section: 'B', instituteName: 'Current School' },
    { academicYear: '2022-2023', grade: '3', section: 'A', instituteName: 'ABC Primary School' },
  ] as TEnrollmentHistoryEntry[],
  previousSchool: {
    name: 'ABC Primary School',
    address: '123 Education Lane, Bangalore',
    lastGrade: '3',
    lastAcademicYear: '2022-2023',
  } as TPreviousSchool,
  enrollmentDocuments: ['doc-1', 'doc-2'],
  bankDetails: {
    accountNumber: '1234567890123456',
    ifscCode: 'HDFC0001234',
    bankName: 'HDFC Bank',
    branchName: 'Connaught Place',
  },
  documents: [
    mockDocument,
    {
      ...mockDocument,
      documentId: 'doc-2',
      documentName: 'Aadhar Card - Priya Sharma',
      documentType: mockDocument.documentType,
      status: mockDocument.status,
    },
  ],
  guardianDetails: [
    mockUserDetails,
    {
      ...mockUserDetails,
      id: 'guardian-2',
      basicDetails: {
        ...mockUserDetails.basicDetails,
        firstName: 'Rajesh',
        lastName: 'Sharma',
        gender: mockUserDetails.basicDetails.gender,
      },
      contactDetails: {
        ...mockUserDetails.contactDetails,
        email: {
          email: 'rajesh.sharma@example.com',
          isVerified: true,
        },
        phone: {
          countryCode: '+91',
          phoneNumber: '9123456789',
          isVerified: true,
        },
      },
    },
  ],
  feeDetails: {
    studentId: 'cdd0f6bc-864e-4e9d-8651-a4b0252dac60',
    userId: 'd72dd2eb-c9c4-4acd-a2f2-6d36bd33c6e1',
    instituteId: 'f4d37581-b92b-43f6-9e5f-c337ed71df91',
    feeComponentId: '8111',
    feePaymentSchedule: FEE_PAYMENT_SCHEDULE.MONTHLY,
    feeComponents: [
      {
        id: 'fee-comp-1',
        description: 'Tuition Fee for the academic year 2025-2026',
        status: TStatus.PARTIAL,
        componentId: 'fee_8111',
        amount: 25000,
        paidAmount: 15000,
        componentName: 'Tuition',
        dueDate: '2025-12-15T00:00:00.000Z',
        academicYear: 2025,
        purpose: 'fee_tuition',
        instituteRef: 'f4d37581-b92b-43f6-9e5f-c337ed71df91',
        createdBy: mockUserAction.userId,
      },
      {
        id: 'fee-comp-2',
        description: 'Library Fee for the academic year 2025-2026',
        status: TStatus.PAID,
        componentId: 'fee_8112',
        amount: 5000,
        paidAmount: 5000,
        componentName: 'Library',
        dueDate: '2025-12-10T00:00:00.000Z',
        academicYear: 2025,
        purpose: 'fee_library',
        instituteRef: 'f4d37581-b92b-43f6-9e5f-c337ed71df91',
        createdBy: mockUserAction.userId,
      },
      {
        id: 'fee-comp-3',
        description: 'Laboratory Fee for the academic year 2025-2026',
        status: TStatus.UNPAID,
        componentId: 'fee_8113',
        amount: 3000,
        paidAmount: 0,
        componentName: 'Laboratory',
        dueDate: '2025-12-20T00:00:00.000Z',
        academicYear: 2025,
        purpose: 'fee_laboratory',
        instituteRef: 'f4d37581-b92b-43f6-9e5f-c337ed71df91',
        createdBy: mockUserAction.userId,
      },
    ],
    createdBy: mockUserAction.userId,
  },
};
